"use strict";
import ProspectContainer from 'emun.prospect/prospect-container'
import ProspectList from 'emun.prospect/prospect-list'
import ProspectProfile from 'emun.prospect/prospect-profile'
import ProspectStatus from 'emun.prospect/prospect-status'
import ProspectPrompt from 'emun.prospect/prospect-prompt'
import ProspectActivityChart from 'emun.prospect/prospect-activity-chart'
import ProspectPerformanceRep from 'emun.prospect/prospect-performance-rep'
import ProspectPerformanceRegion from 'emun.prospect/prospect-performance-region'

const deps = [
    'emun.auth',
    'webutils',
    'webforms',
    'webmodals',
    'emun.retailer',
    'ui.router'];

angular.module('emun.prospect', deps)
.component('prospectContainer', ProspectContainer)
.component('prospectList', ProspectList)
.component('prospectProfile', ProspectProfile)
.component('prospectStatus', ProspectStatus)
.component('prospectActivityChart', ProspectActivityChart)
.component('prospectPerformanceRep', ProspectPerformanceRep)
.component('prospectPerformanceRegion', ProspectPerformanceRegion)
.service('prospectPrompt', ProspectPrompt);